import React, { Component } from 'react';
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { withStyles } from '@material-ui/core/styles';

import NewUser from '../components/Profile/New';
import EditUser from '../components/Profile/EditUser';

import api from '../api/backend'

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
    addCourse: {
        marginBottom: 20
    },
    icon: {
        marginRight: theme.spacing.unit * 2,
    },
    heroUnit: {
        // backgroundColor: theme.palette.background.paper,
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
    },
    heroContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

class UserManager extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { users: [], tmpUsers: [] }
    }

    onUserCreated = () => {
        this.getUsers()
    }

    onUserUpdated = () => {
        this.getUsers()
    }

    getUsers = () => {
        api.getUsers(true).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ users: json, tmpUsers: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากผุ้ใช้ทั้งหมดได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    find = () => {
        const { tmpUsers, term } = this.state
        if (term.length > 0) {
            this.setState({ users: tmpUsers.filter((e) => { return e.firstName.includes(term) || e.lastName.includes(term) ||  e.nickName.includes(term) || e.tel.includes(term) }) })
        } else {
            this.setState({ users: tmpUsers })
        }
    }

    componentDidMount() {
        this.getUsers()
    }

    render() {
        const { classes } = this.props;
        const { users } = this.state;
        return (
            <main>
                {/* Hero unit */}
                <div className={classes.heroUnit}>
                    <div className={classes.heroContent}>
                        <Typography variant="display2" align="center" color="inherit" gutterBottom>
                            ผู้ใช้งานทั้งหมด
            </Typography>
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <Input
                                placeholder="Search…"
                                disableUnderline
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                onChange={(event) => { this.setState({ term: event.target.value }) }}
                                onKeyPress={(ev) => {
                                    if (ev.key === 'Enter') {
                                        this.find()
                                        ev.preventDefault()
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={classNames(classes.layout, classes.cardGrid)}>
                    <Grid container justify="center">
                        <Grid item xs={4}>
                            <NewUser onCreated={this.onUserCreated} />
                        </Grid>
                    </Grid>

                    <Paper className={classes.root}>
                        <Table className={classes.table} padding="dense">
                            <TableHead>
                                <TableRow>
                                    <TableCell>ชื่อนามสกุล</TableCell>
                                    {/* <TableCell numeric>ชื่อเข้าใช้ระบบ</TableCell> */}
                                    <TableCell numeric>ชื่อเล่น</TableCell>
                                    {/* <TableCell numeric>อีเมลล์</TableCell> */}
                                    {/* <TableCell numeric>เบอร์โทรศัพท์</TableCell> */}
                                    {/* <TableCell numeric>ประเภท</TableCell> */}
                                    <TableCell numeric>สถานะ</TableCell>
                                    <TableCell numeric>สถานะการใช้งาน</TableCell>
                                    <TableCell numeric></TableCell>
                                    <TableCell numeric></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {users.sort((a,b) => { return b.id - a.id }).map(row => {
                                    return (
                                        <EditUser key={row.id} user={row} onUpdated={this.onUserUpdated} />
                                        // <TableRow key={row.id}>
                                        //     <TableCell component="th" scope="row">
                                        //         {row.firstName} {row.lastName}
                                        //     </TableCell>
                                        //     <TableCell numeric>{row.nickName}</TableCell>
                                        //     <TableCell numeric>{row.email}</TableCell>
                                        //     <TableCell numeric>{row.tel}</TableCell>
                                        //     <TableCell numeric>{row.role}</TableCell>
                                        // </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </Paper>
                </div>
            </main>
        );
    }
}

export default withStyles(styles)(UserManager);